export default __webpack_public_path__ + "static/media/instagram-page.c00f0717.png";